import React, {memo} from 'react';
import styled from 'styled-components';
import {Title3, Body} from '../../components/Typography';
import appConfig from '../../../app-config';
import IQFoodEmptyCart from './ClientEmptyCart/IQFoodEmptyCart';

const EmptyCartWrapper = styled.div`
  margin: auto;
  margin-top: 50px;
`;

const EmptyCartIcon = styled.div`
  padding: 14px;
  color: ${props => props.theme.emptyCartColor};
  margin: auto;
  border-radius: 4px;
  border: 2px dashed ${props => props.theme.emptyCartColor};
`;

const Title3Wrapper = styled(Title3)`
  text-transform: ${props => props.theme.reviewCheckoutPageTitle};
  margin-bottom: auto;
  font-weight: 600;
`;

const EmptyWrapper = styled.div`
  display: grid;
  grid-gap: 20px;
  margin: 0 52px;
  text-align: center;
  line-height: 1.5;
  color: ${props => props.theme.emptyCartFontColor};
  font-family: ${props => props.theme.primaryFontFontFamily};
`;

const EmptyCart = () => {
  if (appConfig.appSource === 'iQ') {
    return <IQFoodEmptyCart />;
  }
  return (
    <div>
      <Title3Wrapper>Order Summary</Title3Wrapper>
      <div>
        <EmptyWrapper>
          <EmptyCartWrapper>
            <EmptyCartIcon
              className="fal fa-shopping-cart"
              style={{fontSize: '32px'}}
            />
          </EmptyCartWrapper>
          <div>Your Cart is Empty Add Items to Your Order to Checkout...</div>
        </EmptyWrapper>
      </div>
    </div>
  );
};

export default EmptyCart;
